/* eslint-disable max-len */
import React from 'react';
import classNames from 'classnames';
import {setTestId} from 'js/reusable/testing/setTestId';

export interface LogoProps {
	className?: string;
	light?: boolean;
	colored?: boolean;
}

function AlephLogo({light = false, className, colored = false}: LogoProps) {
	const mbsLogoColor: string = light ? 'tw-fill-white' : 'tw-fill-black';
	const byTextClassnames: string = classNames(
		{
			'tw-fill-green-500': colored,
		}
	);
	const svgClassNames: string = classNames(
		'tw-h-full',
		className
	);

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			data-name="Layer 1"
			version="1.1"
			viewBox="0 0 250 200"
			className={svgClassNames}
			data-testid={setTestId('logo__aleph-svg')}
		>
			<g id="Layer_1-2" 
				data-name="Layer 1"
				className={mbsLogoColor}
			>
				<g>
					<g>
						<path className="cls-2" 
							d="m26.31.6l33.69,89.52L93.61.6h26.23v116.79h-20.21v-38.5l2.01-51.5-34.49,90h-14.52L20.21,32.74v46.15s0,38.5,0,38.5H0V.6h26.31Z" 
						/>
						<path className="cls-2" 
							d="m99.63,117.39V.59h40.03c13.21,0,23.26,2.65,30.16,7.94,6.9,5.29,10.35,13.18,10.35,23.66,0,5.35-1.44,10.16-4.33,14.44-2.89,4.28-7.11,7.59-12.67,9.95,6.31,1.71,11.19,4.93,14.64,9.67,3.45,4.73,5.17,10.42,5.17,17.05,0,10.96-3.52,19.39-10.55,25.27-7.03,5.88-17.1,8.82-30.2,8.82h-42.59Zm20.29-67.62h19.89c6.31,0,11.24-1.43,14.8-4.29,3.56-2.86,5.33-6.91,5.33-12.15,0-5.78-1.64-9.95-4.93-12.51-3.29-2.57-8.41-3.85-15.36-3.85h-19.73v32.81Zm0,14.92v36.5h22.54c6.36,0,11.34-1.58,14.92-4.73,3.58-3.15,5.37-7.54,5.37-13.16,0-12.14-6.2-18.34-18.61-18.61h-24.22Z"
						/>
						<path className="cls-2" 
							d="m229.64,88.32c0-5.13-1.8-9.09-5.41-11.87-3.61-2.78-10.12-5.59-19.53-8.42-9.41-2.83-16.9-5.99-22.46-9.47-10.64-6.68-15.96-15.4-15.96-26.15,0-9.41,3.84-17.17,11.51-23.26,7.67-6.1,17.63-9.14,29.88-9.14,8.13,0,15.37,1.5,21.74,4.49,6.36,3,11.36,7.26,15,12.79,3.64,5.53,5.45,11.67,5.45,18.41h-20.21c0-6.1-1.91-10.87-5.74-14.32-3.82-3.45-9.29-5.17-16.4-5.17-6.63,0-11.78,1.42-15.44,4.25-3.66,2.84-5.49,6.79-5.49,11.87,0,4.28,1.98,7.85,5.94,10.71,3.96,2.86,10.48,5.64,19.57,8.34,9.09,2.7,16.39,5.78,21.9,9.22,5.51,3.45,9.55,7.41,12.11,11.87,2.57,4.47,3.85,9.69,3.85,15.68,0,9.73-3.73,17.47-11.19,23.22-7.46,5.75-17.58,8.62-30.36,8.62-8.45,0-16.22-1.56-23.3-4.69-7.09-3.13-12.59-7.45-16.52-12.95-3.93-5.51-5.76-11.92-5.76-19.25h20.16c0,6.63,2.19,11.77,6.58,15.4,4.38,3.64,10.67,5.45,18.85,5.45,7.06,0,12.36-1.43,15.92-4.29,3.56-2.86,5.33-6.64,5.33-11.35Z"
						/>
					</g>
					<g className={byTextClassnames}>
						<path className="cls-2" 
							d="m167.21,172.23v-32.38h5.12v32.38h-5.12Z"
						/>
						<path className="cls-2" 
							d="m188.31,172.65c-6.52,0-11.22-4.27-11.22-11.26v-.34c0-6.86,4.7-11.43,11.01-11.43,5.5,0,10.45,3.26,10.45,11.17v1.48h-16.21c.17,4.19,2.29,6.56,6.1,6.56,3.09,0,4.7-1.23,5.08-3.39h4.95c-.72,4.66-4.49,7.2-10.16,7.2h0Zm-5.88-13.8h11.05c-.25-3.81-2.2-5.5-5.38-5.5s-5.17,2.07-5.67,5.5Z"
						/>
						<path className="cls-2" 
							d="m203.13,179.8v-29.71h5.12v3.56c1.23-2.12,3.98-4.02,7.24-4.02,5.54,0,9.82,4.11,9.82,11.26v.34c0,7.11-4.11,11.43-9.82,11.43-3.51,0-6.05-1.74-7.24-3.89v11.05h-5.12Zm11.09-11.22c3.77,0,5.84-2.54,5.84-7.28v-.34c0-4.91-2.54-7.32-5.88-7.32-3.56,0-6.1,2.41-6.1,7.32v.34c0,4.95,2.42,7.28,6.14,7.28Z"
						/>
						<path className="cls-2"
							d="m229.91,172.23v-32.38h5.12v13.76c1.06-2.16,3.51-3.98,7.15-3.98,4.45,0,7.58,2.58,7.58,8.68v13.93h-5.12v-13.46c0-3.34-1.36-4.87-4.4-4.87-2.88,0-5.21,1.78-5.21,5.29v13.04h-5.12Z"
						/>
						<path className="cls-1" 
							d="m163.02,172.23h-6.09l-10.04-24.84,3.05-7.54,13.08,32.38h0Zm-25.93-7.58l-3.04,7.58h1.32c2.87,0,5.56-1.78,6.56-4.48l3.01-7.58h-1.32c-2.87,0-5.52,1.78-6.53,4.47h0Z"
						/>
						<path className="cls-2" 
							d="m94.72,172.44h2.41v-1.86c.87,1.36,2.52,2.27,4.39,2.27,3.78,0,6.27-2.94,6.27-7.1s-2.35-7.13-6.22-7.13c-1.9,0-3.53.94-4.45,2.25v-7.85h-2.41v19.41Zm2.27-6.71c0-3.22,1.68-5.21,4.14-5.21,1.26,0,2.27.47,3.02,1.44.76.97,1.12,2.25,1.12,3.8s-.36,2.8-1.12,3.77c-.76.97-1.76,1.47-3.02,1.47-2.4,0-4.14-2.16-4.14-5.27Z"
						/>
						<path className="cls-2" 
							d="m109.05,159.07l5.4,12.9-2.46,6.32h2.55l7.25-19.22h-2.52l-3.55,10.18-4-10.18h-2.66Z" 
						/>
					</g>
				</g>
			</g>
		</svg>
	);
}

export default AlephLogo;
